export enum ServiceType {
    'Allied Health' = 1,
    'Antenatal' = 2,
    'Audiologist' = 3,
    'Chiropractor' = 5,
    'Consultant' = 6,
    'Cosmetic' = 7,
    'Dietitian' = 9,
    'General Practitioner' = 10,
    'Mens Health' = 11,
    'Nurse' = 12,
    'Optometry' = 13,
    'Osteopath' = 14,
    'Physiotherapy' = 15,
    'Podiatry' = 16,
    'Psychology' = 17,
    'Remedial Massage Therapy' = 18,
    'Skin Check' = 19,
    'Special Tests' = 20,
    'Specialist' = 21,
    'Spirometry' = 22,
    'Travel Clinic' = 23,
    "Women's Health" = 24,
    'Personal Trainer' = 25,
    'Exercise Physiology' = 26,
    'Hormone Therapy' = 27,
    'Weight Management' = 28,
    'Telehealth' = 29,
    'Flu Clinic' = 30,
    'Care Plan' = 31,
    'Health Assessment' = 32,
    'Counselling' = 33,
    'Pathology' = 34,
    "Children's Health & Immunisations" = 35,
    'Integrative Medicine' = 36,
    'Myotherapy' = 37,
    'Occupational Health' = 38,
    'Home Visit' = 39,
    'Vascular Treatments' = 40,
    'Lactation Consultant' = 41,
    'Phone Consult' = 42,
    'COVID-19 Drive Thru Clinic' = 43,
    'Midwife' = 44,
    'Postnatal Care' = 45,
    'Breastfeeding / Tongue Tie' = 46,
    'CU Health' = 47,
    'Aesthetics' = 48,
    'Respiratory Clinic' = 49,
    'Skin' = 50,
    'Face to Face' = 51,
    'Flu Vaccine' = 52,
    'COVID Vaccine' = 53,
    'Results Appointment' = 54,
    'Nurse Practitioner' = 55,
    'In Practice Visit' = 56,
    'Pre-Employment Medicals' = 57,
    'Baby Clinic' = 58,
    'Psychiatry' = 59,
    'Infectious Symptoms Clinic' = 60,
    'X1' = 61,
    'X2' = 62,
    'X3' = 63,
    'X4' = 64,
    'X5' = 65,
    'X6' = 66,
    'X7' = 67,
    'X8' = 68,
    'X9' = 69,
    'X10' = 70,
    'X11' = 71,
    'X12' = 72,
    'X13' = 73,
    'X14' = 74,
    'X15' = 75,
    'X16' = 76,
    'X17' = 77,
    'X18' = 78,
    'X19' = 79,
    'X20' = 80,
    'Pain Management' = 81,
    'Medicinal Cannabis' = 82,
    'Covid / Flu Vaccine' = 83,
    'Skin Procedure' = 84,
    'OSHC/OVHC' = 85,
    'Orthopedic Surgeon' = 86,
    'Geriatrics' = 87,
    'Dive Medicals' = 88,
    'Cardiology' = 89,
    'Cold & Flu Clinic' = 90,
    'Weekend Appointments' = 91,
    'Immunisation Clinic' = 92,
    'Private GP' = 93,
    'Starter program' = 94,
    'Pain Clinic' = 95,
    'Paediatrics' = 96,
    'Gynaecology' = 97,
    'General Surgeon' = 98,
    'Gastroenterology' = 99,
    'Pain Specialist' = 100,
    'X21' = 101,
    'X22' = 102,
    'X23' = 103,
    'X24' = 104,
    'X25' = 105,
    'X26' = 106,
    'X27' = 107,
    'X28' = 108,
    'X29' = 109,
    'X30' = 110,
    'X31' = 111,
    'X32' = 112,
    'X33' = 113,
    'X34' = 114,
    'X35' = 115,
    'X36' = 116,
    'X37' = 117,
    'X38' = 118,
    'X39' = 119,
    'X40' = 120,
    'X41' = 121,
    'X42' = 122,
    'X43' = 123,
    'X44' = 124,
    'X45' = 125,
    'X46' = 126,
    'X47' = 127,
    'X48' = 128,
    'X49' = 129,
    'X50' = 130,
    'Weekend and Public Holidays' = 131,
    'Medical Abortion ' = 132,
    'X51' = 133,
    'X52' = 134,
    'X53' = 135,
    'X54' = 136,
    'X55' = 137,
    'X56' = 138,
    'X57' = 139,
    'X58' = 140,
    'X59' = 141,
    'X60' = 142,
    'X61' = 143,
    'X62' = 144,
    'X63' = 145,
    'X64' = 146,
    'X65' = 147,
    'X66' = 148,
    'X67' = 149,
    'X68' = 150,
    'X69' = 151,
    'X70' = 152,
    'X71' = 153,
    'X72' = 154,
    'X73' = 155,
    'X74' = 156,
    'X75' = 157,
    'X76' = 158,
    'X77' = 159,
    'X78' = 160,
    'X79' = 161,
    'X80' = 162,
    "Worker's Compensation" = 163,
    'Medical Termination' = 164,
    "Women's Health Physiotherapy" = 165,
    'Travel Health' = 166,
    'ADHD Assessments' = 167,
    'Obstetrician & Gynaecologist' = 168,
    'GP Mental Health' = 169,
    'Adult Vaccinations' = 170,
    'Wound Management' = 171,
    'Therapeutic Injectable' = 172,
    'Nurse Procedures' = 173,
    'GP Telehealth' = 174,
    'Psychology Telehealth' = 175,
    'New Patient' = 176,
    'Baricare stream' = 177,
    'Flexi stream' = 178,
    'X81' = 179,
    'X82' = 180,
    'X83' = 181,
    'X84' = 182,
    'X85' = 183,
    'X86' = 184,
    'X87' = 185,
    'X88' = 186,
    'X89' = 187,
    'X90' = 188,
    'X91' = 189,
    'X92' = 190,
    'X93' = 191,
    'X94' = 192,
    'X95' = 193,
    'X96' = 194,
    'X97' = 195,
    'X98' = 196,
    'X99' = 197,
    'X100' = 198,
    'Infusions' = 199,
    'Medicals' = 200,
    'Mental Health' = 201,
    'Long COVID' = 202,
    'Contraception' = 203,
    'Children Age Immunisations' = 204,
    'Copy of Results' = 205,
    'Diabetes Educator' = 206,
    'Vasectomy' = 207,
    'Complete Health Check' = 208,
    'Acupuncture' = 209,
    'Naturopathy' = 210,
    'Speech Pathology' = 211,
    'Sexual Health' = 212,
    'Juliet Laser' = 213,
    'MiraDry' = 214,
    'Vitamin Infusions' = 215,
    'X101' = 216,
    'X102' = 217,
    'X103' = 218,
    'X104' = 219,
    'X105' = 220,
    'X106' = 221,
    'X107' = 222,
    'X108' = 223,
    'X109' = 224,
    'X110' = 225,
    'X111' = 226,
    'X112' = 227,
    'X113' = 228,
    'X114' = 229,
    'X115' = 230,
    'X116' = 231,
    'X117' = 232,
    'X118' = 233,
    'X119' = 234,
    'X120' = 235,
    'X121' = 236,
    'X122' = 237,
    'X123' = 238,
    'X124' = 239,
    'X125' = 240,
    'X126' = 241,
    'X127' = 242,
    'X128' = 243,
    'X129' = 244,
    'X130' = 245,
    'After hours/Home Visit' = 246,
    'X131' = 247,
    'X132' = 248,
    'X133' = 249,
    'X134' = 250,
    'X135' = 251,
    'X136' = 252,
    'X137' = 253,
    'X138' = 254,
    'X139' = 255,
    'X140' = 256,
    'X141' = 257,
    'X142' = 258,
    'X143' = 259,
    'X144' = 260,
    'X145' = 261,
    'X146' = 262,
    'X147' = 263,
    'X148' = 264,
    'X149' = 265,
    'X150' = 266,
    'X151' = 267,
    'X152' = 268,
    'X153' = 269,
    'X154' = 270,
    'X155' = 271,
    'X156' = 272,
    'X157' = 273,
    'X158' = 274,
    'X159' = 275,
    'X160' = 276,
    'X161' = 277,
    'X162' = 278,
    'X163' = 279,
    'X164' = 280,
    'X165' = 281,
    'X166' = 282,
    'X167' = 283,
    'X168' = 284,
    'X169' = 285,
    'X170' = 286,
    'X171' = 287,
    'X172' = 288,
    'X173' = 289,
    'X174' = 290,
    'X175' = 291,
    'X176' = 292,
    'X177' = 293,
    'X178' = 294,
    'X179' = 295,
    'X180' = 296,
    'X181' = 297,
    'X182' = 298,
    'X183' = 299,
    'X184' = 300,
    'X185' = 301,
    'X186' = 302,
    'X187' = 303,
    'X188' = 304,
    'X189' = 305,
    'X190' = 306,
    'X191' = 307,
    'X192' = 308,
    'X193' = 309,
    'X194' = 310,
    'X195' = 311,
    'X196' = 312,
    'X197' = 313,
    'X198' = 314,
    'X199' = 315,
    'X200' = 316,
    'Skin Cancer Doctor' = 317,
    'Private Telehealth' = 318,
    'Smoking Cessation Advice' = 319,
    'Urgent Care' = 320,
    'Hearing Check' = 321,
    'Procedure' = 322,
    'Paediatric Physiotherapy' = 323,
    'Occupational Therapy' = 324,
    'Shingles Vaccine' = 325,
    'Women and Baby Clinic' = 326,
    'Maternity' = 327,
    'X201' = 328,
    'X202' = 329,
    'X203' = 330,
    'X204' = 331,
    'X205' = 332,
    'X206' = 333,
    'X207' = 334,
    'X208' = 335,
    'X209' = 336,
    'X210' = 337,
    'X211' = 338,
    'X212' = 339,
    'X213' = 340,
    'X214' = 341,
    'X215' = 342,
    'X216' = 343,
    'X217' = 344,
    'X218' = 345,
    'X219' = 346,
    'X220' = 347,
    'X221' = 348,
    'X222' = 349,
    'X223' = 350,
    'X224' = 351,
    'X225' = 352,
    'X226' = 353,
    'X227' = 354,
    'X228' = 355,
    'X229' = 356,
    'X230' = 357,
    'X231' = 358,
    'X232' = 359,
    'X233' = 360,
    'X234' = 361,
    'X235' = 362,
    'X236' = 363,
    'X237' = 364,
    'X238' = 365,
    'X239' = 366,
    'X240' = 367,
    'X241' = 368,
    'X242' = 369,
    'X243' = 370,
    'X244' = 371,
    'X245' = 372,
    'X246' = 373,
    'X247' = 374,
    'X248' = 375,
    'X249' = 376,
    'X250' = 377,
    'General Physician' = 378,
    'Sauna' = 379,
    'NDIS Support Co-Ordinator' = 380,
    'Teaching and Learning Facilitators' = 381,
    'Chinese Medicine Practitioner' = 382,
    'Nutritionist & Health Coach' = 383,
    'Oral Health Therapist' = 384,
    'LGBTIQA Health' = 385,
    'Skin Cancer Clinic' = 386,
    'Vaccine' = 387,
    'Veteran Health' = 388,
    'Dietitian/DEXA' = 390,
    'Vein Consultation' = 391,
    '1TE GP Visit' = 392,
    'General Practitioner & Integrative Medicine' = 393,
    'Classes & Workshops' = 394,
    'Minor Surgery' = 395,
    'After Hours Phone Consult' = 396,
    'Injections' = 397,
    'Muscle, Arthritis, Fracture and Sports Injury' = 398,
    'Beauty Therapist' = 399,
    'Shockwave Therapy' = 400,
    'Iron Infusion' = 401,
    'North Sydney Bears' = 402,
    'Student Health' = 403,
    'Hypnotherapy' = 404,
    'Paediatric OT' = 405,
    'Paediatric Speech Pathology' = 406,
    'Kinesiology' = 407,
    'Anaesthetics' = 408,
    'Video' = 409,
    'Sports Medicine' = 410,
    'X251' = 411,
    'X252' = 412,
    'X253' = 413,
    'X254' = 414,
    'X255' = 415,
    'X256' = 416,
    'X257' = 417,
    'X258' = 418,
    'X259' = 419,
    'X260' = 420,
    'X261' = 421,
    'X262' = 422,
    'X263' = 423,
    'X264' = 424,
    'X265' = 425,
    'X266' = 426,
    'X267' = 427,
    'X268' = 428,
    'X269' = 429,
    'X270' = 430,
    'X271' = 431,
    'X272' = 432,
    'X273' = 433,
    'X274' = 434,
    'X275' = 435,
    'X276' = 436,
    'X277' = 437,
    'X278' = 438,
    'X279' = 439,
    'X280' = 440,
    'X281' = 441,
    'X282' = 442,
    'X283' = 443,
    'X284' = 444,
    'X285' = 445,
    'X286' = 446,
    'X287' = 447,
    'X288' = 448,
    'X289' = 449,
    'X290' = 450,
    'X291' = 451,
    'X292' = 452,
    'X293' = 453,
    'X294' = 454,
    'X295' = 455,
    'X296' = 456,
    'X297' = 457,
    'X298' = 458,
    'X299' = 459,
    'X300' = 460,
    'Yoga' = 461,
    'Lymphoedema Clinic' = 462,
    'Expert GP - Dermatology/Skin Cancer Specialist' = 463,
    'Dentistry' = 464,
    'Member' = 465,
    'Non-Member' = 466,
    'Antenatal Lactation' = 467,
    'Postnatal Lactation' = 471,
    'Endocrinology' = 469,
    'PRP/Prolotherapy' = 470,
    'Heart Health Check' = 474,
    'Physiotherapy and Chirotherapy' = 475,
    'Reflexology' = 476,
    'Childhood Immunisation' = 477,
    'Health Coach' = 478,
    'Perinatal Care' = 479,
    'Spot Check' = 480,
    'Laser' = 481,
    'Occupational Medicals' = 482,
    'LDK Greenway' = 483,
    'Lifestyle Medicine' = 484,
    'LDK Amberfield' = 485,
}
